export default function AboutSection() {
  return (
    <section id="about" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
          关于我们
        </h2>
        <p className="text-sm text-foreground-600 mb-8">了解每日大赛入口</p>

        <div className="rounded-2xl bg-background-100 p-6 md:p-10">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 mb-6">
            <i className="ri-live-line text-3xl text-primary-600"></i>
          </div>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
            每日大赛入口是国内专业的赛事视频聚合平台，致力于为体育竞技、电子竞技、综艺选秀、才艺比赛等各类型赛事的爱好者提供一站式高清视频在线观看服务。作为每日大赛官网级平台，我们每日更新最新赛事回放、精彩集锦和全场录像，所有内容均支持每日大赛免费观看，无需注册、无需付费，即可享受高清流畅的观看体验。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
            平台持续优化每日大赛在线观看体验，覆盖篮球、足球、电竞、音乐、舞蹈、拳击、美食、棋牌等数十个品类，为不同兴趣的观众提供多元化的每日大赛全集内容。每日大赛最新视频第一时间上线，让您不错过任何一场精彩对决。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-foreground-500">
            <span>内容覆盖 10+ 赛事品类</span>
            <span className="hidden sm:inline text-foreground-300">·</span>
            <span>日更新 50+ 比赛视频</span>
            <span className="hidden sm:inline text-foreground-300">·</span>
            <span>累计服务 100万+ 观众</span>
          </div>
        </div>
      </div>
    </section>
  );
}